import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../../shared/permissions';
import { type RouterSpecsFragment } from '../../../../api/fragments/RouterSpecs';
import hasPermissions from '../../../../utilities/hasPermissions';
import { useLayoutDrawer } from './LayoutDrawer';

export type LayoutActionsProps = {
    router: RouterSpecsFragment;
};

const LayoutActions = ({ router }: LayoutActionsProps) => {
    const { t } = useTranslation(['routerDetails']);
    const drawer = useLayoutDrawer();

    if (!hasPermissions(router.permissions, [permissionKind.updateRouter])) {
        return null;
    }

    return (
        <>
            <Button onClick={drawer.open} type="primary">
                {t('routerDetails:layouts.updateActionButton')}
            </Button>
            {drawer.render(router)}
        </>
    );
};

export default LayoutActions;
